export default "__VITE_ASSET__Dd1lBkGq__"